// Development: localhost
// Production: https://api.cf-extras.ro
export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.cf-extras.ro'
  : 'http://localhost:5210';
